export const getData = (key = "") => {
  let data = [
    {
      DayOfMonth: 1,
      Currency: "UGX",
      UniqueDepositPlayers: 11,
      UniqueWithdrawPlayers: 2,
      Deposits: 30200,
      Withdrawals: 9295,
    },
    {
      DayOfMonth: 2,
      Currency: "UGX",
      UniqueDepositPlayers: 10,
      UniqueWithdrawPlayers: 2,
      Deposits: 71600,
      Withdrawals: 39000,
    },
    {
      DayOfMonth: 3,
      Currency: "UGX",
      UniqueDepositPlayers: 12,
      UniqueWithdrawPlayers: 1,
      Deposits: 48000,
      Withdrawals: 5000,
    },
    {
      DayOfMonth: 4,
      Currency: "UGX",
      UniqueDepositPlayers: 15,
      UniqueWithdrawPlayers: 1,
      Deposits: 40000,
      Withdrawals: 2000,
    },
    {
      DayOfMonth: 5,
      Currency: "UGX",
      UniqueDepositPlayers: 10,
      UniqueWithdrawPlayers: "0",
      Deposits: 23500,
      Withdrawals: "0",
    },
    {
      DayOfMonth: 6,
      Currency: "UGX",
      UniqueDepositPlayers: 15,
      UniqueWithdrawPlayers: 3,
      Deposits: 103300,
      Withdrawals: 37900,
    },
    {
      DayOfMonth: 7,
      Currency: "UGX",
      UniqueDepositPlayers: 9,
      UniqueWithdrawPlayers: 2,
      Deposits: 85200,
      Withdrawals: 54600,
    },
    {
      DayOfMonth: 8,
      Currency: "UGX",
      UniqueDepositPlayers: 4,
      UniqueWithdrawPlayers: 2,
      Deposits: 5900,
      Withdrawals: 2000,
    },
    {
      DayOfMonth: 9,
      Currency: "UGX",
      UniqueDepositPlayers: 5,
      UniqueWithdrawPlayers: "0",
      Deposits: 17500,
      Withdrawals: "0",
    },
    {
      DayOfMonth: 10,
      Currency: "UGX",
      UniqueDepositPlayers: 4,
      UniqueWithdrawPlayers: 1,
      Deposits: 7180,
      Withdrawals: 9000,
    },
    {
      DayOfMonth: 11,
      Currency: "UGX",
      UniqueDepositPlayers: 7,
      UniqueWithdrawPlayers: "0",
      Deposits: 24462,
      Withdrawals: "0",
    },
    {
      DayOfMonth: 12,
      Currency: "UGX",
      UniqueDepositPlayers: 7,
      UniqueWithdrawPlayers: "0",
      Deposits: 23000,
      Withdrawals: "0",
    },
    {
      DayOfMonth: 13,
      Currency: "UGX",
      UniqueDepositPlayers: 6,
      UniqueWithdrawPlayers: "0",
      Deposits: 14700,
      Withdrawals: "0",
    },
    {
      DayOfMonth: 14,
      Currency: "UGX",
      UniqueDepositPlayers: 9,
      UniqueWithdrawPlayers: "0",
      Deposits: 16700,
      Withdrawals: "0",
    },
    {
      DayOfMonth: 15,
      Currency: "UGX",
      UniqueDepositPlayers: 6,
      UniqueWithdrawPlayers: "0",
      Deposits: 16200,
      Withdrawals: "0",
    },
    {
      DayOfMonth: 16,
      Currency: "UGX",
      UniqueDepositPlayers: 6,
      UniqueWithdrawPlayers: "0",
      Deposits: 21100,
      Withdrawals: "0",
    },
    {
      DayOfMonth: 17,
      Currency: "UGX",
      UniqueDepositPlayers: 2,
      UniqueWithdrawPlayers: "0",
      Deposits: 102000,
      Withdrawals: "0",
    },
    {
      DayOfMonth: 18,
      Currency: "UGX",
      UniqueDepositPlayers: 5,
      UniqueWithdrawPlayers: "0",
      Deposits: 28500,
      Withdrawals: "0",
    },
    {
      DayOfMonth: 19,
      Currency: "UGX",
      UniqueDepositPlayers: 5,
      UniqueWithdrawPlayers: "0",
      Deposits: 32880,
      Withdrawals: "0",
    },
    {
      DayOfMonth: 20,
      Currency: "UGX",
      UniqueDepositPlayers: 10,
      UniqueWithdrawPlayers: "0",
      Deposits: 80100,
      Withdrawals: "0",
    },
    {
      DayOfMonth: 21,
      Currency: "UGX",
      UniqueDepositPlayers: 4,
      UniqueWithdrawPlayers: "0",
      Deposits: 175500,
      Withdrawals: "0",
    },
    {
      DayOfMonth: 22,
      Currency: "UGX",
      UniqueDepositPlayers: 6,
      UniqueWithdrawPlayers: "0",
      Deposits: 203890,
      Withdrawals: "0",
    },
    {
      DayOfMonth: 23,
      Currency: "UGX",
      UniqueDepositPlayers: 6,
      UniqueWithdrawPlayers: "0",
      Deposits: 19100,
      Withdrawals: "0",
    },
    {
      DayOfMonth: 24,
      Currency: "UGX",
      UniqueDepositPlayers: 2,
      UniqueWithdrawPlayers: "0",
      Deposits: 15000,
      Withdrawals: "0",
    },
    {
      DayOfMonth: 25,
      Currency: "UGX",
      UniqueDepositPlayers: 3,
      UniqueWithdrawPlayers: "0",
      Deposits: 7600,
      Withdrawals: "0",
    },
  ]

  return data
}
